import { createApp } from '@app/adapters/create-app'
import BudgetActionsSelect from '../sections/budget-actions-select'

const renderBudgetActionsSelect = (tableStructure) => {
  document
    .querySelectorAll('[data-behaviour="budget-actions-select"]')
    .forEach((element) => {
      createApp(BudgetActionsSelect, {
        rowType: element.dataset.rowType,
        rowElementId: element.dataset.rowElementId,
        tableStructure: tableStructure,
        defaultValues: {
          copyValue: element.dataset.defaultCopyValue,
          divider: element.dataset.defaultDivider,
          spreadValue: element.dataset.defaultSpreadValue,
          seasonality: '100',
        },
      }).mount(element)
    })
}

onDomLoad(function () {
  if (!document.querySelector('.budget-table')) return

  const table = document.querySelector('[data-table-structure]')
  const tableStructure = JSON.parse(table.dataset.tableStructure)

  renderBudgetActionsSelect(tableStructure)
})
